class CnerIgnoregitConfig {
  static developer_geek = 'prod';
}

export default CnerIgnoregitConfig;
